(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["get-involved"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // ---- TLTLA Mission Popup core ----
    const registry = window.__tltlaMissionPopups || (window.__tltlaMissionPopups = []);

    const makeToken = () => {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    };

    const initSection = (root) => {
      if (!root || root.dataset.tltlaInitialized === 'true') return;
      root.dataset.tltlaInitialized = 'true';

      const sectionId = root.dataset.sectionId;
      const overlay = root.querySelector('[data-tltla-overlay]');
      const dialog = root.querySelector('[data-tltla-dialog]');
      const form = root.querySelector('[data-tltla-form]');
      const supportType = root.querySelector('[data-tltla-support-type]');
      const panels = Array.from(root.querySelectorAll('[data-tltla-panel]'));
      const companyField = root.querySelector('[data-tltla-company]');
      const companyOptional = root.querySelector('[data-tltla-company-optional]');
      const companyRequired = root.querySelector('[data-tltla-company-required]');
      const submitButton = root.querySelector('[data-tltla-submit]');
      const submitLabel = root.querySelector('[data-tltla-submit-label]');
      const submitLoading = root.querySelector('[data-tltla-submit-loading]');
      const status = root.querySelector('[data-tltla-status]');
      const endpoint = root.dataset.endpoint || '';
      let previousFocus = null;
      let activeToken = '';
      let responseTimer = null;

      if (!overlay || !dialog || !form || !supportType) return;

      const focusableSelector = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled]):not([type="hidden"])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
      ].join(',');

      const setStatus = (message, state = '') => {
        status.textContent = message || '';
        if (state) status.dataset.state = state;
        else delete status.dataset.state;
      };

      const setSubmitting = (isSubmitting) => {
        submitButton.disabled = isSubmitting;
        submitLabel.hidden = isSubmitting;
        submitLoading.hidden = !isSubmitting;
      };

      const updateConditionalFields = () => {
        const selected = supportType.value;

        panels.forEach((panel) => {
          const isActive = panel.dataset.tltlaPanel === selected;
          panel.hidden = !isActive;
          panel.disabled = !isActive;

          panel.querySelectorAll('input, select, textarea').forEach((field) => {
            field.disabled = !isActive;
            field.required = isActive && field.hasAttribute('data-required-when-visible');
          });
        });

        const companyIsRequired = selected === 'Funding Opportunities' || selected === 'Partnering';
        companyField.required = companyIsRequired;
        companyOptional.hidden = companyIsRequired;
        companyRequired.hidden = !companyIsRequired;
      };

      const open = () => {
        previousFocus = document.activeElement;
        overlay.hidden = false;
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tltla-popup-open');
        requestAnimationFrame(() => supportType.focus());
      };

      const close = () => {
        overlay.hidden = true;
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('tltla-popup-open');
        if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      };

      const resetAfterSuccess = () => {
        form.reset();
        updateConditionalFields();
      };

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-tltla-local-open]')) open();
        if (event.target.closest('[data-tltla-close]')) close();
        if (event.target === overlay) close();
      });

      supportType.addEventListener('change', updateConditionalFields);

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }

        if (event.key !== 'Tab') return;
        const focusable = Array.from(dialog.querySelectorAll(focusableSelector));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      form.addEventListener('submit', (event) => {
        updateConditionalFields();

        if (!endpoint || !endpoint.startsWith('https://script.google.com/')) {
          event.preventDefault();
          setStatus('Form setup is incomplete. Add the Google Apps Script /exec URL in the section settings.', 'error');
          return;
        }

        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          return;
        }

        activeToken = makeToken();
        form.elements.submission_id.value = activeToken;
        form.elements.submission_token.value = activeToken;
        form.elements.submitted_at.value = new Date().toISOString();
        form.elements.source_url.value = window.location.href;
        form.elements.page_title.value = document.title;

        setStatus('Submitting your information...', '');
        setSubmitting(true);

        clearTimeout(responseTimer);
        responseTimer = window.setTimeout(() => {
          setSubmitting(false);
          setStatus('We could not confirm the submission. Please try again.', 'error');
          activeToken = '';
        }, 20000);
      });

      window.addEventListener('message', (event) => {
        const isGoogleOrigin = event.origin === 'https://script.google.com' || event.origin.endsWith('.googleusercontent.com');
        if (!isGoogleOrigin || !event.data || event.data.type !== 'tltla-form-response') return;
        if (!activeToken || event.data.token !== activeToken) return;

        clearTimeout(responseTimer);
        setSubmitting(false);
        setStatus(event.data.message, event.data.ok ? 'success' : 'error');

        if (event.data.ok) resetAfterSuccess();
        activeToken = '';
      });

      updateConditionalFields();
      registry.push({ root, open, close });

      const autoOpenSeconds = Number(root.dataset.autoOpenSeconds || 0);
      const autoOpenOnce = root.dataset.autoOpenOnce === 'true';
      const storageKey = `tltla-popup-seen-${sectionId}`;
      let hasSeen = false;

      try {
        hasSeen = autoOpenOnce && sessionStorage.getItem(storageKey) === 'true';
      } catch (error) {
        hasSeen = false;
      }

      const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
      const shouldAutoOpen = autoOpenSeconds > 0 && (isDesignMode || !hasSeen);

      if (shouldAutoOpen) {
        window.setTimeout(() => {
          open();

          if (autoOpenOnce && !isDesignMode) {
            try { sessionStorage.setItem(storageKey, 'true'); } catch (error) {}
          }
        }, autoOpenSeconds * 1000);
      }
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches('[data-tltla-section]')) initSection(scope);
      scope.querySelectorAll('[data-tltla-section]').forEach(initSection);
    };

    // ---- Global trigger for `data-tltla-popup-open` (yellow button) ----
    if (!window.__tltlaMissionGlobalBound) {
      window.__tltlaMissionGlobalBound = true;

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('a[href="#join-the-mission"], [data-tltla-popup-open]');
        const activePopup = registry.find((item) => item.root && item.root.isConnected);
        if (!trigger || !activePopup) return;
        event.preventDefault();
        activePopup.open();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tltla-mission-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registry = window.__tltlaMissionPopups || (window.__tltlaMissionPopups = []);

    const makeToken = () => {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    };

    const initSection = (root) => {
      if (!root || root.dataset.tltlaInitialized === 'true') return;
      root.dataset.tltlaInitialized = 'true';

      const sectionId = root.dataset.sectionId;
      const overlay = root.querySelector('[data-tltla-overlay]');
      const dialog = root.querySelector('[data-tltla-dialog]');
      const form = root.querySelector('[data-tltla-form]');
      const supportType = root.querySelector('[data-tltla-support-type]');
      const panels = Array.from(root.querySelectorAll('[data-tltla-panel]'));
      const companyField = root.querySelector('[data-tltla-company]');
      const companyOptional = root.querySelector('[data-tltla-company-optional]');
      const companyRequired = root.querySelector('[data-tltla-company-required]');
      const submitButton = root.querySelector('[data-tltla-submit]');
      const submitLabel = root.querySelector('[data-tltla-submit-label]');
      const submitLoading = root.querySelector('[data-tltla-submit-loading]');
      const status = root.querySelector('[data-tltla-status]');
      const endpoint = root.dataset.endpoint || '';
      let previousFocus = null;
      let activeToken = '';
      let responseTimer = null;

      if (!overlay || !dialog || !form || !supportType) return;

      const focusableSelector = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled]):not([type="hidden"])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
      ].join(',');

      const setStatus = (message, state = '') => {
        status.textContent = message || '';
        if (state) status.dataset.state = state;
        else delete status.dataset.state;
      };

      const setSubmitting = (isSubmitting) => {
        submitButton.disabled = isSubmitting;
        submitLabel.hidden = isSubmitting;
        submitLoading.hidden = !isSubmitting;
      };

      const updateConditionalFields = () => {
        const selected = supportType.value;

        panels.forEach((panel) => {
          const isActive = panel.dataset.tltlaPanel === selected;
          panel.hidden = !isActive;
          panel.disabled = !isActive;

          panel.querySelectorAll('input, select, textarea').forEach((field) => {
            field.disabled = !isActive;
            field.required = isActive && field.hasAttribute('data-required-when-visible');
          });
        });

        const companyIsRequired = selected === 'Funding Opportunities' || selected === 'Partnering';
        companyField.required = companyIsRequired;
        companyOptional.hidden = companyIsRequired;
        companyRequired.hidden = !companyIsRequired;
      };

      const open = () => {
        previousFocus = document.activeElement;
        overlay.hidden = false;
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tltla-popup-open');
        requestAnimationFrame(() => supportType.focus());
      };

      const close = () => {
        overlay.hidden = true;
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('tltla-popup-open');
        if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      };

      const resetAfterSuccess = () => {
        form.reset();
        updateConditionalFields();
      };

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-tltla-local-open]')) open();
        if (event.target.closest('[data-tltla-close]')) close();
        if (event.target === overlay) close();
      });

      supportType.addEventListener('change', updateConditionalFields);

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }

        if (event.key !== 'Tab') return;
        const focusable = Array.from(dialog.querySelectorAll(focusableSelector));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      form.addEventListener('submit', (event) => {
        updateConditionalFields();

        if (!endpoint || !endpoint.startsWith('https://script.google.com/')) {
          event.preventDefault();
          setStatus('Form setup is incomplete. Add the Google Apps Script /exec URL in the section settings.', 'error');
          return;
        }

        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          return;
        }

        activeToken = makeToken();
        form.elements.submission_id.value = activeToken;
        form.elements.submission_token.value = activeToken;
        form.elements.submitted_at.value = new Date().toISOString();
        form.elements.source_url.value = window.location.href;
        form.elements.page_title.value = document.title;

        setStatus('Submitting your information...', '');
        setSubmitting(true);

        clearTimeout(responseTimer);
        responseTimer = window.setTimeout(() => {
          setSubmitting(false);
          setStatus('We could not confirm the submission. Please try again.', 'error');
          activeToken = '';
        }, 30000);
      });

      window.addEventListener('message', (event) => {
        let response = event.data;

        if (typeof response === 'string') {
          try {
            response = JSON.parse(response);
          } catch (error) {
            return;
          }
        }

        if (!response || response.type !== 'tltla-form-response') return;

        // The random token ties the response to this exact form submission.
        // Safari can expose Apps Script sandbox messages with origin "null",
        // so a matching token is required before accepting that sandboxed origin.
        if (!activeToken || response.token !== activeToken) return;

        const isGoogleOrigin =
          event.origin === 'https://script.google.com' ||
          event.origin === 'https://script.googleusercontent.com' ||
          event.origin.endsWith('.googleusercontent.com');
        const isSandboxedAppsScriptOrigin = event.origin === 'null';

        if (!isGoogleOrigin && !isSandboxedAppsScriptOrigin) return;

        clearTimeout(responseTimer);
        setSubmitting(false);
        setStatus(response.message, response.ok ? 'success' : 'error');

        if (response.ok) resetAfterSuccess();
        activeToken = '';
      });

      updateConditionalFields();
      registry.push({ root, open, close });

      const autoOpenSeconds = Number(root.dataset.autoOpenSeconds || 0);
      const autoOpenOnce = root.dataset.autoOpenOnce === 'true';
      const storageKey = `tltla-popup-seen-${sectionId}`;
      let hasSeen = false;

      try {
        hasSeen = autoOpenOnce && sessionStorage.getItem(storageKey) === 'true';
      } catch (error) {
        hasSeen = false;
      }

      const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
      const shouldAutoOpen = autoOpenSeconds > 0 && (isDesignMode || !hasSeen);

      if (shouldAutoOpen) {
        window.setTimeout(() => {
          open();

          if (autoOpenOnce && !isDesignMode) {
            try { sessionStorage.setItem(storageKey, 'true'); } catch (error) {}
          }
        }, autoOpenSeconds * 1000);
      }
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches('[data-tltla-section]')) initSection(scope);
      scope.querySelectorAll('[data-tltla-section]').forEach(initSection);
    };

    if (!window.__tltlaMissionGlobalBound) {
      window.__tltlaMissionGlobalBound = true;
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('a[href="#join-the-mission"], [data-tltla-popup-open]');
        const activePopup = registry.find((item) => item.root && item.root.isConnected);
        if (!trigger || !activePopup) return;
        event.preventDefault();
        activePopup.open();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
